import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import BlobFilter from "~/components/BlobFilter";
import useFileDocumentFilter from "../actions/useFileDocumentFilter";
import FilterChip from "~/components/FilterChip";
import { useDispatch, useSelector } from "react-redux";
import { setBlobFilterStates } from "~/Pages/Process/actions/attachmentsSlice";

const TitleBreadcrumbs = () => {
  const { id, service_id, process_id, type, request_type, request_id } =
    useParams();
  const dispatch = useDispatch();
  const { states, handleBackClick } = useFileDocuments({
    id,
    service_id,
    type,
    process_id,
    request_type,
    request_id,
  });

  const {
    selectedService,
    selectedProcess,
    selectedType,
    selectedRequestType,
    selectedRequest,
    isPayslipFolder,
    entity_detail,
    selectedCategory,
  } = states || {};
  const {
    handleFilterProps,
    handleFilterChange,
    removeFnRef,
    setFilterData,
    filterData,
    handleRemoveFilter,
    disableFilter,
  } = useFileDocumentFilter({ states });

  const { blobFilterStates } = useSelector((state) => state.attachments);
  const breadcrumbs = [
    "Files & Documents",
    service_id && selectedService?.name,
    type && selectedType?.name,
    process_id && selectedProcess?.name,
    request_type && selectedRequestType?.name,
    request_id && selectedRequest?.name,
    isPayslipFolder && "Payslips",
    selectedCategory?.name,
  ].filter(Boolean);
  return (
    <>
      <div className="title-breadcrumbs flex justify-content-between align-items-center">
        <div className="flex align-items-center">
          {service_id && (
            <i
              className="pi pi-arrow-left folder-back-icon"
              onClick={handleBackClick}
            />
          )}
          <p>
            {breadcrumbs.slice(0, -1).map((crumb, index) => (
              <span key={index} className="document-heading">
                {crumb} /{" "}
              </span>
            ))}
            {breadcrumbs.length > 0 && (
              <span className="document-bold-heading">
                {breadcrumbs.at(-1)}
              </span>
            )}
          </p>
        </div>
        {!isPayslipFolder && (
          <BlobFilter
            onApply={({ value, group }) => {
              setFilterData(value);
              dispatch(
                setBlobFilterStates({
                  ...blobFilterStates,
                  filterLoading: true,
                }),
              );
            }}
            onRemove={(fn) => (removeFnRef.current = fn)}
            onFilterChange={({ value, grouped }) => {
              handleFilterChange(grouped);
            }}
            showCategory={handleFilterProps()?.showCategory}
            showServiceLine={handleFilterProps()?.showServiceLine}
            showYears={handleFilterProps()?.showYears}
            showEntity={handleFilterProps()?.showEntity}
            serviceLine={handleFilterProps()?.serviceLine}
            showRequestType={handleFilterProps()?.showRequestType}
            disabled={disableFilter}
            template={handleFilterProps()?.template}
            entityId={entity_detail?.id}
          />
        )}
      </div>
      <div className="mb-4">
        <FilterChip
          filterData={filterData}
          removeFilter={(id) => {
            handleRemoveFilter(id);
          }}
        />
      </div>
    </>
  );
};

export default TitleBreadcrumbs;
